import { render, staticRenderFns } from "./VASmallBox.vue?vue&type=template&id=40767034&"
import script from "./VASmallBox.vue?vue&type=script&lang=js&"
export * from "./VASmallBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports